// extracted by mini-css-extract-plugin
export var buttonContent = "_3p-0";
export var centered = "_3p-1";
export var centeredFlex = "_3p-2";
export var errorText = "_3p-3";
export var icon = "_3p-4";
export var iconButtonContent = "_3p-5";
export var monospace = "_3p-6";
export var padded = "_3p-7";